var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.26709,
    width: 4.26668,
    height: 1.06667,
    fill: "#232323"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.2002,
    y: 8.5332,
    width: 6.40003,
    height: 1.06667,
    fill: "#232323"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5332,
    y: 1.06665,
    width: 1.06667,
    height: 1.06667,
    fill: "#232323"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5332,
    y: 5.33325,
    width: 1.06667,
    height: 1.06667,
    fill: "#232323"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.60059,
    y: 2.1333,
    width: 1.06667,
    height: 3.20001,
    fill: "#232323"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.06667,
    height: 1.06667,
    transform: "matrix(-1 0 0 1 4.26709 1.06665)",
    fill: "#232323"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 1.06667,
    height: 1.06667,
    transform: "matrix(-1 0 0 1 4.26709 5.33325)",
    fill: "#232323"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 4.26668,
    height: 1.06667,
    transform: "matrix(-1 0 0 1 8.5332 6.3999)",
    fill: "#232323"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 1.06667,
    height: 1.06667,
    transform: "matrix(-1 0 0 1 3.2002 9.6001)",
    fill: "#232323"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 1.06667,
    height: 1.06667,
    transform: "matrix(-1 0 0 1 2.1333 10.6667)",
    fill: "#232323"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 1.06667,
    height: 4.26668,
    transform: "matrix(-1 0 0 1 1.06689 11.7334)",
    fill: "#232323"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 9.60059,
    y: 9.6001,
    width: 1.06667,
    height: 1.06667,
    fill: "#232323"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 10.667,
    y: 10.6667,
    width: 1.06667,
    height: 1.06667,
    fill: "#232323"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7334,
    y: 11.7334,
    width: 1.06667,
    height: 4.26668,
    fill: "#232323"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 1.06667,
    height: 3.20001,
    transform: "matrix(-1 0 0 1 3.2002 2.1333)",
    fill: "#232323"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.1ec2d4ac1a383c24091b8ba2d2306876.svg";
export { ForwardRef as ReactComponent };